import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .emptyAvatarContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

    .emptyAvatar {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      border: 2px solid ${({theme}) => theme.colors.surface.surface};
      background-color: ${({theme}) => theme.colors.surface.surfaceOutline};
      margin-left: -8px;
    }
  }

  .emptyText {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: ${({theme}) => theme.colors.surface.onSurfacePlaceholder};
    margin-top: 4px;
  }
`;
